import { useReducer } from "react"
import "lib/@hooks/useEvent"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { useReviewDecisionByAmendsKey } from "../lib/use-review-decision-by-amends-key"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"
import { AmendsChanged } from "../schedule-editor-event-definitions.mjs"

/**
 * Rejection/approval decisions keyed by amendsKey for inline editor banners.
 * Recomputes when amends change locally (new schedules inherit prior decisions).
 */
export function useScheduleEditorReviewDecisions() {
    const { projectId, scheduleId, draftId } = useScheduleEditorIds()
    const [, forceUpdate] = useReducer(tick, 0)
    const session = readScheduleEditorSession(draftId)

    AmendsChanged(draftId).useEvent(forceUpdate)

    return useReviewDecisionByAmendsKey({
        projectId,
        scheduleId,
        reviewCycle: session?.reviewCycle,
    })
}

function tick(n) {
    return n + 1
}
